export const SESSION_CHANGED = 'auth-session-changed';

export function readSession () {
  try {
    return {
      member: JSON.parse(localStorage.getItem('member')),
      token: JSON.parse(localStorage.getItem('token'))
    };
  } catch {
    return { member: null, token: null };
  }
}

export function saveSession ({ member, token }) {
  if (!member || !token?.accessToken) return;
  localStorage.setItem('token', JSON.stringify(token));
  localStorage.setItem('member', JSON.stringify(member));
  window.dispatchEvent(new Event(SESSION_CHANGED));
}

export function clearSession () {
  localStorage.removeItem('member');
  localStorage.removeItem('token');
  localStorage.removeItem('isShowHeader');
  window.dispatchEvent(new Event(SESSION_CHANGED));
}
